var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00488281,
    y: 0.654297,
    width: 72,
    height: 72,
    rx: 20,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1017 50.7507C31.4141 50.7507 26.7264 50.7507 22.0388 50.7507C21.8098 50.7507 21.5778 50.7507 21.3479 50.727C20.1743 50.6174 19.7025 49.8268 20.2029 48.7579C20.6372 47.8351 21.111 46.9359 21.5709 46.0229C23.7424 41.7242 25.9138 37.4261 28.0852 33.1286C28.1523 32.9973 28.2224 32.8661 28.3004 32.7407C28.8472 31.8643 29.7355 31.7409 30.4353 32.4969C30.9288 33.026 31.3463 33.6201 31.7865 34.1936C34.0237 37.1171 36.2609 40.042 38.4982 42.9681C39.4753 44.2414 40.7061 44.3105 41.854 43.1655C42.4235 42.597 42.9802 42.0137 43.5566 41.4501C44.5959 40.4335 45.7754 40.4947 46.6242 41.6801C48.3278 44.0588 49.9889 46.469 51.658 48.8714C51.7884 49.0599 51.8883 49.2677 51.9541 49.4873C52.1159 50.0391 51.8869 50.4832 51.3273 50.6303C50.9764 50.7143 50.6162 50.7531 50.2554 50.7458C45.5401 50.7537 40.8222 50.7553 36.1017 50.7507Z",
    fill: "#CBCBCB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6143 27.1957C46.6131 28.1133 46.3395 29.0098 45.8282 29.7716C45.3168 30.5335 44.5908 31.1263 43.7421 31.475C42.8934 31.8238 41.9603 31.9126 41.061 31.7304C40.1618 31.5481 39.3369 31.103 38.6909 30.4513C38.045 29.7997 37.6071 28.9709 37.4327 28.0701C37.2583 27.1693 37.3554 26.237 37.7115 25.3914C38.0676 24.5458 38.6668 23.825 39.4331 23.3203C40.1994 22.8157 41.0983 22.5499 42.0158 22.5568C43.2376 22.5723 44.4043 23.0673 45.2645 23.9351C46.1247 24.8028 46.6095 25.9739 46.6143 27.1957Z",
    fill: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankImage);
export default __webpack_public_path__ + "static/media/blank-image.8fc6b9b165d6c3fc14ca443e03d6a249.svg";
export { ForwardRef as ReactComponent };